<template>
      <div class="type">
          <div class="type-top">
            <div class="type-top-left"></div>
            第二类医疗器械备案凭证
          </div>
          <div class="type-text" v-if="record != null">
            <div class="CodeText">
              备案号： <span>{{ record.BRFilingCode }}</span>
            </div>
            <div class="CodeText">
              企业名称： <span>{{ record.BRCompanyName }}</span>
            </div>
            <div class="CodeText">
              经营方式： <span>{{ record.BRBusinessMode }}</span>
            </div>
            <div class="CodeText">
              住所： <span>{{ record.BRAddress }}</span>
            </div>
            <div class="CodeText">
              经营场所： <span>{{ record.BRBusinessAddr }}</span>
            </div>
            <div class="CodeText">
              库房地址： <span>{{ record.BRWarehouseAddr }}</span>
            </div>
            <div class="CodeText">
              法定代表人： <span>{{ record.BRLegalRepresentative }}</span>
            </div>
            <div class="CodeText">
              企业负责人： <span>{{ record.BRCEO }}</span>
            </div>
            <div class="CodeText">
              二类经营范围： <span>{{ record.BRSecInvSort }}</span>
            </div>
            <div class="CodeText">
              备案日期： <span>{{ record.BRFilingDate }}</span>
            </div>
            <div class="CodeText">
              提交时间： <span>{{ record.CreateTime }}</span>
            </div>
            <div class="CodeText">
              审核时间： <span>{{ record.VerifyTime }}</span>
            </div>
            <div class="CodeText">
              驳回时间：<span>{{ record.RejectTime }}</span>
            </div>
            <div class="CodeText">
              驳回原因： <span>{{ record.RejectReason }}</span>
            </div>
            <div class="CodeText">
              第二类医疗器械备案凭证：
              <div class="imgBox">
                <!-- ${ config.http_URL } + -->
                <img :src="`${record.BRPhotoURL}`">
              </div>

              <div class="imgTop3"><img src="@/assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto" @click="imgShowClick(record.BRPhotoURL)"></div>
            </div>

          </div>
        </div>
</template>

<script>
  export default {
    components:{},
    props:{
        record: {
            type: Object
        }
    },
    data(){
      return {
          
      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{
        imgShowClick(par){
            this.$emit('imgShowClick' , par)
        }
    },
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>
@import url('../index.less');
// .type {
//     width: 98.6%;
//     border: 1px solid #e6e6e6;
//     font-size: 17px;
//     color: #333333;
//     font-weight: 500;
//     padding: 10px 10px 10px 0;
//     margin: 0 auto;
  
//     .type-top {
//       width: 100%;
//       border-bottom: 1px solid #e6e6e6;
//       font-weight: bold;
//       color: #333333;
//       font-size: 14px;
//       text-indent: 16px;
//       line-height: 16px;
//       padding-bottom: 10px;
  
//       .type-top-left {
//         width: 3px;
//         height: 16px;
//         display: inline-block;
//         background-color: #e71d43;
//         float: left;
//       }
//     }
//     .type-text {
//       margin-top: 12px;
//     }
//     .CodeText {
//       display: inline-block;
//       width: 430px;
//       margin-left: 30px;
//       font-size: 14px;
//       font-weight: 500;
//       // border: 1px solid red;
//       color: #999999;
//       margin-top: 12px;
//       position: relative;
  
//       .imgBox {
//         display: inline-block;
//         width: 96px;
//         height: 96px;
//         border: 1px solid #e6e6e6;
  
//         img {
//           width: 96px;
//           height: 96px;
//           vertical-align: top;
//         }
//       }
//       span {
//         display: inline-block;
//         color: #333333;
//         font-weight: 500;
//         img {
//           width: 96px;
//           height: 96px;
//           vertical-align: top;
//         }
//       }
//     }
//   }
  
</style>